import { createApp } from 'vue';
import App from './agreement.vue';

createApp(App).mount('#agreement');
